import styles from "./styles.module.scss";
import classNames from "classnames";
import { ReactComponent as CheckIcon } from "assets/icons/ic_player_check.svg";
import { IPlayerSettings } from "../player-control/player-control";
import { IContentAsset } from "models/dto/ZoomiLxp/Models/ContentModels/IContentAsset";

interface PlayerSpeedProps {
	isShow: boolean;
	selectedSubtitleId: number;
	onChangeSubtitle?: (subtitle: IPlayerSettings) => void;
	tracks?: IContentAsset[];
}

const PlayerCaptions = (props: PlayerSpeedProps) => {
	const { isShow, selectedSubtitleId, onChangeSubtitle, tracks } = props;

	if (!isShow) return <></>;

	const subtitlesList: IPlayerSettings[] = [
		{ value: 0, label: "Off" },
		...(tracks?.map((track) => ({
			value: track.uploadedFileId,
			label: track.label,
		})) ?? []),
	];

	return (
		<div className={classNames(styles.player_captions)}>
			<div className={styles.player_captions__header}>Subtitles</div>
			<div className={styles.player_captions__body}>
				<ul className={styles.player_captions__list}>
					{subtitlesList.map((item) => (
						<li className={styles.player_captions__item} key={item.value} onClick={() => onChangeSubtitle?.(item)}>
							{item.value === selectedSubtitleId && <CheckIcon className={styles.player_captions__icon} />}
							<div className={styles.player_captions__label}>{item.label}</div>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
};

export default PlayerCaptions;
